import axios from 'axios';
axios.defaults.headers.post['Content-Type']  =  'application/x-www-form-urlencoded';
import qs from 'qs';

const checkoutProcess = axios.create({
    baseURL: URL_CHECKOUT_API
});
//Prod https://checkout.e-xact.com/payment
//Demo https://rpm.demo.e-xact.com/payment
const rpmEXact = axios.create({
    baseURL: 'https://rpm.demo.e-xact.com',
});

checkoutProcess.interceptors.request.use((request) => {
    request.headers.Authorization = localStorage.getItem('token');
    return request;
}, error => Promise.reject(error));

const getByOrder = (order_code) => checkoutProcess.get(`/checkout/getByOrder/${order_code}`);

const orderPay = (orderPayData) => checkoutProcess.post(`/checkout/orderPay/`, qs.stringify(orderPayData));

const getSeats = (id_course, catalogue_path) => checkoutProcess.get(`/checkout/getSeats/${id_course}${catalogue_path||''}`);

const blockSeat = (id_course, seatData) => checkoutProcess.put(`/checkout/blockSeat/${id_course}`, qs.stringify(seatData));

const unBlockSeat = (id_course, seatData) => checkoutProcess.put(`/checkout/unBlockSeat/${id_course}`, qs.stringify(seatData));

const getBlockInfo = (id_course) => checkoutProcess.get(`/checkout/getBlockInfo/${id_course}`);

const checkCoupon = (id_course, couponData) => checkoutProcess.post(`/checkout/checkCoupon/${id_course}`, qs.stringify(couponData));

const orderSeat = (orderSeatData) => checkoutProcess.post(`/checkout/orderSeat/`, qs.stringify(orderSeatData), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});

const orderRefund = (orderRefund) => checkoutProcess.post('/checkout/orderRefund/', qs.stringify(orderRefund));

const refundsByTransaction = (refundsByTransaction) => checkoutProcess.post('/checkout/refundsByTransaction/', qs.stringify(refundsByTransaction));

const moveBlockSeat = (id_course, moveBlockSeatData) => checkoutProcess.put(`/checkout/moveBlockSeat/${id_course}`, qs.stringify(moveBlockSeatData));

const releaseCurrentBlockSeat = (id_course) => checkoutProcess.put(`/checkout/releaseCurrentBlockSeat/${id_course}`);

const getCheckoutOptions = (id_course) => checkoutProcess.get(`/checkout/getCheckoutOptions/${id_course}`);

const saveCheckoutOptions = (id_course, seatData) => checkoutProcess.put(`/checkout/saveCheckoutOptions/${id_course}`, qs.stringify(seatData));

const hostedCheckout = (formData) => rpmEXact.post('/payment', qs.stringify(formData));

const recertificate = (data) => checkoutProcess.post(`course/recertificate`, qs.stringify(data));

const orderForm = (orderSeatData) => checkoutProcess.post(`/checkout/orderForm/`, qs.stringify(orderSeatData), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});

export default {
    getByOrder,
    orderPay,
    getSeats,
    blockSeat,
    unBlockSeat,
    getBlockInfo,
    checkCoupon,
    orderSeat,
    orderRefund,
    refundsByTransaction,
    moveBlockSeat,
    releaseCurrentBlockSeat,
    getCheckoutOptions,
    saveCheckoutOptions,
    hostedCheckout,
    recertificate,
    orderForm,
};